"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var help_icon_svg_1 = __importDefault(require("@assets/shared/help-icon.svg"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return core_1.createStyles({
        tooltip: (_a = {
                whiteSpace: 'nowrap',
                maxWidth: 'unset'
            },
            _a[theme.breakpoints.up('md')] = {
                marginTop: '-12px',
                padding: '16px',
            },
            _a),
        ownershipHelpIcon: {
            width: '14px',
            verticalAlign: 'middle',
        },
    });
});
var Tooltip = function (_a) {
    var title = _a.title, imageAltText = _a.imageAltText;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Tooltip, { title: title, arrow: true, placement: "top", classes: { tooltip: classes.tooltip } },
        react_1.default.createElement("img", { className: classes.ownershipHelpIcon, src: help_icon_svg_1.default, alt: imageAltText, draggable: false })));
};
exports.default = Tooltip;
